"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnouncementServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class AnnouncementServiceLive {
    async getCompanyAnnouncements(companyId, page, rowsPerPage, sortOrder, sortBy) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/announcements?page=${page}&rowsPerPage=${rowsPerPage}&sortOrder=${sortOrder}&sortBy=${sortBy}`);
        return response.data;
    }
    async getAnnouncement(companyId, announcementId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/announcements/${announcementId}`);
        return response.data;
    }
    async getAttachmentSignedUrl(companyId, announcementId, filename) {
        const url = `/company/${companyId}/announcements/${announcementId}?filename=${filename}`;
        const response = await HttpProvider_1.httpProvider.get(url);
        return response.data;
    }
}
exports.AnnouncementServiceLive = AnnouncementServiceLive;
//# sourceMappingURL=AnnouncementServiceLive.js.map